import React from 'react';
import { PageHeader, AuthDemo } from '../components/common';

const DashboardPage = () => {
  return (
    <div className='h-full bg-gray-50 pb-8'>
      <PageHeader
        title='Dashboard'
        subtitle='Welcome to your SKAI1 Admin Panel'
        breadcrumbs={[{ name: 'Home', href: '/' }, { name: 'Dashboard' }]}
      />
      {/* Stats Cards */}
      {/*       
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8'>
        <div className='bg-white p-6 rounded-lg shadow-sm border border-gray-200'>
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='w-8 h-8 bg-blue-100 rounded-md flex items-center justify-center'>
                <svg
                  className='w-5 h-5 text-blue-600'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z'
                  />
                </svg>
              </div>
            </div>
            <div className='ml-4'>
              <h3 className='text-lg font-medium text-gray-900'>Total Users</h3>
              <p className='text-3xl font-bold text-blue-600'>1,234</p>
              <p className='text-sm text-gray-500 mt-1'>
                ↗ 12% from last month
              </p>
            </div>
          </div>
        </div>

        <div className='bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow'>
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='w-8 h-8 bg-green-100 rounded-md flex items-center justify-center'>
                <svg
                  className='w-5 h-5 text-green-600'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                  />
                </svg>
              </div>
            </div>
            <div className='ml-4'>
              <h3 className='text-lg font-medium text-gray-900'>
                Active Marketers
              </h3>
              <p className='text-3xl font-bold text-green-600'>89</p>
              <p className='text-sm text-gray-500 mt-1'>↗ 5% from last week</p>
            </div>
          </div>
        </div>

        <div className='bg-white p-6 rounded-lg shadow-sm border border-gray-200'>
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='w-8 h-8 bg-purple-100 rounded-md flex items-center justify-center'>
                <svg
                  className='w-5 h-5 text-purple-600'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1'
                  />
                </svg>
              </div>
            </div>
            <div className='ml-4'>
              <h3 className='text-lg font-medium text-gray-900'>
                Monthly Revenue
              </h3>
              <p className='text-3xl font-bold text-purple-600'>$12,456</p>
              <p className='text-sm text-gray-500 mt-1'>↗ 8% from last month</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Recent Activity */}
      {/*       
      <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
        <div className='px-6 py-4 border-b border-gray-200'>
          <h3 className='text-lg font-medium text-gray-900'>Recent Activity</h3>
        </div>
        <div className='p-6'>
          <div className='space-y-4'>
            {[
              {
                action: 'New user registered',
                user: 'John Doe',
                time: '2 minutes ago',
                type: 'user',
              },
              {
                action: 'Marketer updated profile',
                user: 'Jane Smith',
                time: '15 minutes ago',
                type: 'marketer',
              },
              {
                action: 'Role permissions changed',
                user: 'Admin',
                time: '1 hour ago',
                type: 'role',
              },
              {
                action: 'User deactivated',
                user: 'Bob Johnson',
                time: '2 hours ago',
                type: 'user',
              },
            ].map((activity, index) => (
              <div key={index} className='flex items-center space-x-3'>
                <div
                  className={`w-2 h-2 rounded-full ${
                    activity.type === 'user'
                      ? 'bg-blue-500'
                      : activity.type === 'marketer'
                      ? 'bg-green-500'
                      : 'bg-purple-500'
                  }`}
                ></div>
                <div className='flex-1'>
                  <p className='text-sm text-gray-900'>{activity.action}</p>
                  <p className='text-xs text-gray-500'>
                    by {activity.user} • {activity.time}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> 
      */}

      {/* Development Section - Authentication Demo (Remove in production) */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            🔧 Development: Authentication System Demo
          </h2>
          <AuthDemo />
        </div>
      )} */}
    </div>
  );
};

export default DashboardPage;
